import React from 'react';
import { Alert } from "@curves/ui-base";

const PaymentUnsetAlert = () => {
    return (
        <Alert className={'mt-2 flex-grow-1'} variant="filled" severity="error" color="error">
            尚未設定，請儘速設定
        </Alert>
    );
};

export default PaymentUnsetAlert;
